export default {
    namespaced: true,
    state: {
        options: []
    },
    getters: {},
    actions: {
        getSelectOptions({ commit }, { fetchData, fetchApi, param, page }) {
            if (fetchApi) {
                return new Promise((resolve, reject) => {
                    fetchApi()(param)
                        .then((response) => {
                            const options = page ? response.data : response;
                            commit('getOptions', options);
                            resolve(options);
                        })
                        .catch((error) => {
                            reject(error);
                        });
                });
            } else {
                commit('getOptions', fetchData);
                return fetchData;
            }
        }
    },
    mutations: {
        getOptions(state, options) {
            state.options = options;
        }
    }
};
